import moment from 'moment';

// 获取当前最近的合法时间
export const CURRENT_TIME = new Date(moment(new Date()).add(30 - (moment(new Date()).minute() % 30), 'minutes').valueOf());